import { useState, useEffect, useRef } from "react";

// ─── ICONS ────────────────────────────────────────────────────────────────────
const EmailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" /><path d="m2 7 10 7 10-7" />
  </svg>
);
const PhoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z" />
  </svg>
);
const PinIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);
const TikTokIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.32 6.32 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.75a4.85 4.85 0 01-1.01-.06z" />
  </svg>
);
const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);
const YouTubeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);
const XIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
  </svg>
);
const FacebookIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);
const ChevronIcon = () => (
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
    <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// ─── DATA ─────────────────────────────────────────────────────────────────────
const REGULAR_CONTACTS = [
  { Icon: EmailIcon, label: "EMAIL", value: "booking@vegaskarts.com", hint: "Pre-orders & general inquiries", href: "mailto:sales@vegaskarts.com" },
  { Icon: PhoneIcon, label: "PHONE", value: "+1 (702) 751-1911", hint: "Mon-Sun · 9 AM - 9 PM PST", href: "tel:+17027511911" },
  { Icon: PinIcon, label: "LOCATION", value: "Las Vegas, NV 89101", hint: "Strip · Downtown · Red Rock · Lake LV", href: null },
];

const SOCIAL_CONTACTS = [
  { Icon: TikTokIcon, label: "TIKTOK", value: "@vegaskarts", hint: "Short-form · Reels · Clips", href: "https://tiktok.com/@vegaskarts", bg: "rgba(0,0,0,0.6)", border: "rgba(255,255,255,0.14)", color: "#fff" },
  { Icon: InstagramIcon, label: "INSTAGRAM", value: "@vegaskarts", hint: "Behind the scenes & updates", href: "https://instagram.com/vegaskarts", bg: "rgba(225,48,108,0.12)", border: "rgba(225,48,108,0.38)", color: "#e1306c" },
  { Icon: YouTubeIcon, label: "YOUTUBE", value: "Vegas Karts", hint: "Race footage & highlights", href: "https://youtube.com/@vegaskarts", bg: "rgba(255,0,0,0.10)", border: "rgba(255,0,0,0.32)", color: "#ff0000" },
  { Icon: XIcon, label: "X", value: "@vegaskarts", hint: "News & announcements", href: "https://x.com/@vegaskarts", bg: "rgba(255,255,255,0.06)", border: "rgba(255,255,255,0.18)", color: "#fff" },
  { Icon: FacebookIcon, label: "FACEBOOK", value: "Vegas Karts", hint: "Events & community", href: "https://facebook.com/@vegaskarts", bg: "rgba(24,119,242,0.10)", border: "rgba(24,119,242,0.32)", color: "#1877f2" },
];

const HOURS = [
  { day: "Mon - Fri", time: "9:00 AM - 9:00 PM" },
  { day: "Saturday", time: "8:00 AM - 11:00 PM" },
  { day: "Sunday", time: "9:00 AM - 8:00 PM" },
];

const INQUIRY_OPTIONS = [
  "Pre-Order / Booking",
  "Pricing & Packages",
  "Group / Corporate Event",
  "Driver Requirements",
  "Partnership / Media",
  "Other",
];

const MISSIONS = ["THE STRIP — $200", "DOWNTOWN — $150", "RED ROCK — $150", "LAKE LV — $150"];

const TICK_HALF =
  "◆ VK-001 ONLINE \u00a0·\u00a0 PRE-ORDERS OPEN \u00a0·\u00a0 WINTER 2026 \u00a0·\u00a0 DF GOBLIN V2 \u00a0·\u00a0 LAS VEGAS, NV \u00a0·\u00a0 THE STRIP — $200 \u00a0·\u00a0 DOWNTOWN — $150 \u00a0·\u00a0 RED ROCK — $150 \u00a0·\u00a0 LAKE LV — $150 \u00a0·\u00a0 sales@vegaskarts.com \u00a0·\u00a0 +1 (702) 555-0199 \u00a0·\u00a0 ";
const TICK_CONTENT = TICK_HALF.repeat(4) + TICK_HALF.repeat(4);

// ─── SUB-COMPONENTS ───────────────────────────────────────────────────────────
function Ticker({ variant }) {
  return (
    <div className={`vk-ticker-rail${variant === "dark" ? " vk-ticker-dark" : ""}`}>
      <span className="vk-ticker-track">{TICK_CONTENT}</span>
    </div>
  );
}

function CustomSelect({ value, onChange, options, placeholder = "Select..." }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const selected = options.find((o) => o === value);
  return (
    <div className={`vk-custom-select${open ? " open" : ""}`} ref={ref}>
      <button type="button" className="vk-cs-trigger" onClick={() => setOpen((p) => !p)} aria-haspopup="listbox" aria-expanded={open}>
        <span className={`vk-cs-value${!selected ? " placeholder" : ""}`}>{selected || placeholder}</span>
        <span className={`vk-cs-chevron${open ? " flipped" : ""}`}><ChevronIcon /></span>
      </button>
      {open && (
        <ul className="vk-cs-dropdown" role="listbox">
          <li className={`vk-cs-option${!value ? " selected" : ""}`} role="option" onClick={() => { onChange(""); setOpen(false); }}>
            <span className="vk-cs-opt-label">{placeholder}</span>
          </li>
          {options.map((opt) => (
            <li key={opt} className={`vk-cs-option${value === opt ? " selected" : ""}`} role="option" aria-selected={value === opt} onClick={() => { onChange(opt); setOpen(false); }}>
              {value === opt && <span className="vk-cs-check">◆</span>}
              <span className="vk-cs-opt-label">{opt}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function NoiseBg() {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w, h, animId;
    const resize = () => { w = canvas.offsetWidth; h = canvas.offsetHeight; canvas.width = w; canvas.height = h; };
    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = "rgba(255,56,0,0.028)";
      for (let x = 40; x < w; x += 40)
        for (let y = 40; y < h; y += 40) { ctx.beginPath(); ctx.arc(x, y, 0.8, 0, Math.PI * 2); ctx.fill(); }
      for (let i = 0; i < 55; i++) { ctx.fillStyle = `rgba(255,56,0,${Math.random() * 0.06})`; ctx.fillRect(Math.random() * w, Math.random() * h, Math.random() * 1.5, Math.random() * 1.5); }
      for (let i = 0; i < 25; i++) { ctx.fillStyle = `rgba(0,212,255,${Math.random() * 0.025})`; ctx.fillRect(Math.random() * w, Math.random() * h, Math.random() * 1.2, Math.random() * 1.2); }
      animId = requestAnimationFrame(draw);
    };
    resize(); draw();
    window.addEventListener("resize", resize);
    return () => { cancelAnimationFrame(animId); window.removeEventListener("resize", resize); };
  }, []);
  return <canvas ref={ref} className="vk-noise-canvas" />;
}

// ─── MAIN EXPORT ──────────────────────────────────────────────────────────────
export default function PanelInfo({ onNav }) {
  const [chips, setChips] = useState([]);
  const [form, setFormSt] = useState({ fname: "", lname: "", email: "", phone: "", type: "", date: "", msg: "" });
  const [toast, setToast] = useState({ show: false, msg: "", warn: false });

  const set = (k) => (e) => setFormSt((p) => ({ ...p, [k]: e.target.value }));
  const setSelect = (k) => (val) => setFormSt((p) => ({ ...p, [k]: val }));
  const toggleChip = (c) => setChips((p) => p.includes(c) ? p.filter((x) => x !== c) : [...p, c]);

  const showToast = (msg, warn = false) => {
    setToast({ show: true, msg, warn });
    setTimeout(() => setToast((p) => ({ ...p, show: false })), 3500);
  };

  const submit = () => {
    if (!form.fname.trim() || !form.email.trim()) { showToast("⚠  FIRST NAME & EMAIL REQUIRED", true); return; }
    showToast("✓  TRANSMITTED — We'll respond within 24 hrs.");
    setFormSt({ fname: "", lname: "", email: "", phone: "", type: "", date: "", msg: "" });
    setChips([]);
  };

  return (
    <section className="vk-panel" id="panel-info">

      <NoiseBg />

      <div className="vk-main">

        {/* ══════════════ LEFT COLUMN ══════════════ */}
        <div className="vk-left">

          {/* — Hero — */}
          <div className="vk-hero">
            <div className="vk-eyebrow">
              <span className="vk-epip" />
              <span>COMMAND</span>
              <span className="vk-slash">//</span>
              <span>GET IN TOUCH</span>
            </div>
            <h1 className="vk-h1">
              <span>CON</span><span style={{ color: "#FF3800" }}>TACT</span>
            </h1>
            <p className="vk-sub">
              Pre-orders · Inquiries · Driver registry.<br />
              Response guaranteed within 24 hrs.
            </p>
          </div>

          {/* — Social platforms — */}
          <div className="vk-socials-section">
            <div className="vk-section-mini-lbl">// FOLLOW THE MISSION</div>
            <div className="vk-social-list">
              {SOCIAL_CONTACTS.map(({ Icon, label, value, hint, href, bg, border, color }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="vk-social-row">
                  <div className="vk-ico" style={{ background: bg, borderColor: border, color }}>
                    <Icon />
                  </div>
                  <div className="vk-ci-body">
                    <span className="vk-ci-val">{value}</span>
                    <span className="vk-ci-hint">{hint}</span>
                  </div>
                  <span className="vk-social-tag">{label}</span>
                </a>
              ))}
            </div>
          </div>


          {/* — Email / Phone / Location — */}
          <div className="vk-contacts">
            {REGULAR_CONTACTS.map(({ Icon, label, value, hint, href }) => {
              const inner = (
                <>
                  <div className="vk-ico"><Icon /></div>
                  <div className="vk-ci-body">
                    <span className="vk-ci-val">{value}</span>
                    <span className="vk-ci-hint">{hint}</span>
                  </div>
                </>
              );
              return href
                ? <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="vk-ci">{inner}</a>
                : <div key={label} className="vk-ci">{inner}</div>;
            })}
          </div>

          {/* — Operating hours — */}
          {/* <div className="vk-hours">
            <div className="vk-section-mini-lbl">// OPERATING HOURS</div>
            {HOURS.map((h) => (
              <div key={h.day} className="vk-hr-row">
                <span className="vk-hday">{h.day}</span>
                <span className="vk-htime">{h.time}</span>
                <span className="vk-hbadge">OPEN</span>
              </div>
            ))}
          </div> */}

        </div>
        {/* ══════════════ END LEFT ══════════════ */}

        {/* ══════════════ RIGHT / FORM ══════════════ */}
        <div className="vk-right">

          <div className="vk-form-hdr">
            <div className="vk-fhl">
              <span className="vk-or">FORM</span>
              <span className="vk-slash">//</span>
              <span>SEND A MESSAGE</span>
            </div>
          </div>

          <div className="vk-form-body">

            <div className="vk-step-hdr">
              <span className="vk-step-num">01</span>
              <span className="vk-step-lbl">// IDENTITY</span>
              <span className="vk-step-line" />
            </div>

            <div className="vk-row">
              <div className="vk-field">
                <label className="vk-lbl">FIRST NAME *</label>
                <input type="text" placeholder="John" value={form.fname} onChange={set("fname")} />
              </div>
              <div className="vk-field">
                <label className="vk-lbl">LAST NAME</label>
                <input type="text" placeholder="Doe" value={form.lname} onChange={set("lname")} />
              </div>
            </div>

            <div className="vk-row">
              <div className="vk-field">
                <label className="vk-lbl">EMAIL *</label>
                <input type="email" placeholder="you@email.com" value={form.email} onChange={set("email")} />
              </div>
              <div className="vk-field">
                <label className="vk-lbl">PHONE</label>
                <input type="tel" placeholder="+1 (702) 000-0000" value={form.phone} onChange={set("phone")} />
              </div>
            </div>

            <div className="vk-step-hdr">
              <span className="vk-step-num">02</span>
              <span className="vk-step-lbl">// MISSION DETAILS</span>
              <span className="vk-step-line" />
            </div>

            <div className="vk-row">
              <div className="vk-field">
                <label className="vk-lbl">INQUIRY TYPE</label>
                <CustomSelect value={form.type} onChange={setSelect("type")} options={INQUIRY_OPTIONS} placeholder="Select type..." />
              </div>
              <div className="vk-field">
                <label className="vk-lbl">PREFERRED DATE</label>
                <input className="vk-form-input vk-form-input--date" type="date" value={form.date} onChange={set("date")} />
              </div>
            </div>

            <div className="vk-field">
              <div className="vk-div-lbl">MISSION INTEREST</div>
              <div className="vk-chips">
                {MISSIONS.map((m) => (
                  <button key={m} type="button" className={`vk-chip${chips.includes(m) ? " on" : ""}`} onClick={() => toggleChip(m)}>
                    {m}
                  </button>
                ))}
              </div>
            </div>

            <div className="vk-step-hdr">
              <span className="vk-step-num">03</span>
              <span className="vk-step-lbl">// TRANSMISSION</span>
              <span className="vk-step-line" />
            </div>

            <div className="vk-field">
              <label className="vk-lbl">MESSAGE</label>
              <textarea placeholder="Group size, questions, special requests..." value={form.msg} onChange={set("msg")} />
            </div>

            <div className="vk-submit-row">
              <button type="button" className="vk-btn" onClick={submit}>TRANSMIT MESSAGE ▶</button>
              <span className="vk-snote">We respond within 24 hrs.<br />No spam. Ever.</span>
            </div>

          </div>
        </div>
        {/* ══════════════ END RIGHT ══════════════ */}

      </div>

      <Ticker variant="orange" />

      <div className={`vk-toast${toast.show ? " show" : ""}${toast.warn ? " warn" : ""}`}>
        {toast.msg}
      </div>

    </section>
  );
}